/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PumpDischargeGraph
 */
export interface PumpDischargeGraph {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the PumpDischargeGraph interface.
 */
export function instanceOfPumpDischargeGraph(value: object): value is PumpDischargeGraph {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function PumpDischargeGraphFromJSON(json: any): PumpDischargeGraph {
  return PumpDischargeGraphFromJSONTyped(json, false);
}

export function PumpDischargeGraphFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PumpDischargeGraph {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function PumpDischargeGraphToJSON(json: any): PumpDischargeGraph {
  return PumpDischargeGraphToJSONTyped(json, false);
}

export function PumpDischargeGraphToJSONTyped(
  value?: PumpDischargeGraph | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
